import React from 'react'
import Typewriter from "typewriter-effect";

import './HomePage.css'

import { Fade } from 'react-animated-components'

import CV from '../../data/Amal-Mishael-CV.pdf'

export default function HomePage() {
  return (
    <Fade
      ref={{
        current: '[Circular]'
      }}
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
    >
      <div className='HomePage'>
        <div className='HomePageLeft'>
          <h2>Hi, I'm</h2>
          <h1 className="jt --debug">
            <span className="jt__row">
              <span className="jt__text">Hope/Amal</span>
            </span>
            <span className="jt__row jt__row--sibling" aria-hidden="true">
              <span className="jt__text">Hope/Amal</span>
            </span>
            <span className="jt__row jt__row--sibling" aria-hidden="true">
              <span className="jt__text">Hope/Amal</span>
            </span>
            <span className="jt__row jt__row--sibling" aria-hidden="true">
              <span className="jt__text">Hope/Amal</span>
            </span>
          </h1>
          <h2 className='typeWriter'>
            <Typewriter
              options={{
                strings: ['Full-Stack Developer', 'Mechatronics Engineer', 'Artist'],
                autoStart: true,
                loop: true,
              }}
            />
          </h2>
          <a href={CV} className="downloadCV"> Download CV</a>
        </div>
        <div className='HomePageRight'>
          <p className='HomePageIcon'>H</p>
          <h1 className='HomePageLogo'>Hope Website</h1>
        </div>
      </div>
    </Fade>
  )
}
